"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SVGTextIconStyle = _interopRequireDefault(require("./SVGTextIconStyle"));

var _SVGWrapper = _interopRequireDefault(require("./SVGWrapper"));

var SVGIcon = function SVGIcon(props) {
  var wrapperProps = props.wrapperProps,
      icon = props.icon,
      innerProps = (0, _objectWithoutProperties2.default)(props, ["wrapperProps", "icon"]);
  return _react.default.createElement(_SVGWrapper.default, wrapperProps, _react.default.createElement(_SVGTextIconStyle.default, innerProps, icon));
};

SVGIcon.propTyes = {
  wrapperProps: _propTypes.default.node,
  icon: _propTypes.default.string
};
var _default = SVGIcon;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/UIAvatarDisplay/baseStyledComponents/SVGIcon.js
// module id = 421
// module chunks = 209 210 211 212